<template>
    <div class="card mb-5 shadow">
        <div class="card-header">Tâches à facturer</div>
        <div class="card-body">
            <div v-if="loading">
                <loading></loading>
            </div>

            <div v-else>
                <b-alert variant="danger" :show="hasErrors">
                    <span v-html="errorMessage"></span>
                </b-alert>

                <!-- filter -->
                <b-row v-if="!hasErrors" class="mb-3">
                    <b-col md="8" class="my-1"> </b-col>
                    <b-col md="4" class="my-1">
                        <b-form-group class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input
                                    v-model="filter"
                                    placeholder="Entrer la valeur recherchée"
                                />
                                <b-input-group-append>
                                    <b-button
                                        :disabled="!filter"
                                        @click="resetSearch"
                                    >
                                        Effacer
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- /filter -->

                <!-- Table -->
                <b-table
                    responsive
                    small
                    :items="filteredItems"
                    :fields="fields"
                    :filter="filter"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @filtered="onFiltered"
                >
                    <template #cell(client)="data">
                        <span>{{ data.item.client.name }}</span>
                    </template>
                    <template #cell(created_by)="data">
                        <span>{{ data.item.created_by.name }}</span>
                    </template>
                    <template #cell(assigned_to)="data">
                        <span>{{ data.item.assigned_to.name }}</span>
                    </template>
                    <template #cell(achievement_date)="data">
                        <span>{{
                            data.item.achievement_date | moment('DD/MM/YYYY')
                        }}</span>
                    </template>
                    <template #cell(id)="data">
                        <billing-switch :id="data.item.id" />
                    </template>
                </b-table>
                <!-- /Table -->

                <!-- Pagination -->
                <b-row>
                    <b-col md="3" class="my-1 text-center">
                        <b-pagination
                            v-if="totalRows > 0"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            class="my-0"
                            size="sm"
                        ></b-pagination>
                    </b-col>
                    <b-col md="6" class="my-2">
                        <p class="text-center small pt-0">{{ legend }}</p>
                    </b-col>
                    <b-col md="3" class="my-1 text-right">
                        <b-dropdown
                            right
                            split
                            size="sm"
                            :text="perPage + ' éléments par page'"
                        >
                            <b-dropdown-item
                                v-for="pageOption in pageOptions"
                                :key="pageOption"
                                @click="setPerPage(pageOption)"
                            >
                                {{ pageOption }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                </b-row>
                <!-- /Pagination -->
            </div>
        </div>
    </div>
</template>

<script>
import loading from '../../../common/components/loading'
import TableHandler from '../../../common/mixins/TableHandler'
import BillingSwitch from '../../../common/components/BillingSwitch'

export default {
    name: 'TableBillableTasks',

    components: {
        loading,
        BillingSwitch,
    },

    mixins: [TableHandler],

    data() {
        return {
            fields: [
                {
                    key: 'description',
                    label: 'Tâche',
                    class: 'td-sm',
                    thStyle: 'width:50%',
                    sortable: true,
                },
                {
                    key: 'client',
                    label: 'Tiers',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'assigned_to',
                    label: 'Réalisée par',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'created_by',
                    label: 'Assignée par',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'achievement_date',
                    label: 'Réalisée le',
                    class: 'td-sm text-center',
                    sortable: true,
                },
                {
                    key: 'id',
                    label: 'Facturer',
                    class: 'td-sm text-center',
                    sortable: false,
                },
            ],
        }
    },

    created() {
        this.$store.commit('browsing/RESET_EDITING')
        this.$store.commit('browsing/SET_PAGE_NAME', 'billableTasks')
        this.getItems()
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await axios.get('/todo/billable-tasks')
                this.filteredItems = response.data.data
                this.loading = false
                this.updateTotalRows()
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        commentTask(task) {
            this.$store.commit('data/SET_EDITED_TASK', task)
            this.$store.commit('browsing/SET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.edit')
        },
    },
}
</script>

<style scoped></style>
